(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('radioPills', radioPills);

    radioPills.$inject = ['$timeout'];

    function radioPills($timeout) {
        return {
            restrict: 'E',
            scope: {
                items: '<',
                selectedValue: '=ngModel',
                disabled: '=?',
                name: '@',
                required: '=?',
                onChange: '&?'
            },
            templateUrl: '/app/common/radio-pills.html',
            link: function (scope) {

                // Select item
                scope.selectItem = function (item) {
                    // Check if disabled globally or item is disabled
                    if (scope.disabled || item.disabled) return;

                    scope.selectedValue = item.Id;

                    // Trigger onChange callback after digest cycle completes
                    if (scope.onChange) {
                        $timeout(function () {
                            scope.onChange({ item: item, value: item.Id });
                        });
                    }
                };

                // Check if item or container is disabled
                scope.isDisabled = function (item) {
                    return scope.disabled || item.disabled;
                };

                // Check if item is selected
                scope.isSelected = function (item) {
                    return scope.selectedValue === item.Id;
                };

                // Check if item should be shown (active items only)
                scope.shouldShow = function (item) {
                    if (item.hasOwnProperty('isActive')) {
                        return item.isActive;
                    }
                    return true;
                };
            }
        };
    }
})();
